import React from 'react';
import { Layout, Menu, Switch, Typography } from 'antd';

const { Header } = Layout;
const { Title } = Typography;

function TopBar({ isDarkMode, toggleTheme, topBarColor }) {
  const menuItems = [
    { label: 'Dashboard', key: 'dashboard' },
    {
      label: 'Business Entity',
      key: 'businessentity',
      children: [
        { label: 'Screen 1', key: 'screen1' },
        { label: 'Screen 2', key: 'screen2' },
      ],
    },
    {
      label: 'Administration',
      key: 'administration',
      children: [
        { label: 'Screen 1', key: 'screen1' },
        { label: 'Screen 2', key: 'screen2' },
      ],
    },
    { label: 'Templates', key: 'templates' },
    {
      label: 'Master Data',
      key: 'masterdata',
      children: [
        { label: 'Screen 1', key: 'screen1' },
        { label: 'Screen 2', key: 'screen2' },
      ],
    },
    { label: 'Document Management', key: 'documentmanagement' },
    { label: 'Reports', key: 'reports' },
    { label: 'Contact Us', key: 'contact' },
  ];

  return (
    <Header style={{ backgroundColor: topBarColor, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Title level={3} >My Themed App</Title>

      <Menu
        mode="horizontal"
        theme="dark"
        items={menuItems}
        style={{ flex: 1, justifyContent: 'center', borderBottom: 'none' }}
      />

      <Switch
        checked={isDarkMode}
        onChange={toggleTheme}
        checkedChildren="🌙"
        unCheckedChildren="☀️"
        style={{
          backgroundColor: isDarkMode ? '#555' : '#ddd',
          borderColor: topBarColor,
        }}
      />
    </Header>
  );
}

export default TopBar;
